<app-layout-container (tabClick)="onTabClick($event)" [navbarItems]="navbar()" [tabbar]="tabbar()" [useCard]="false">
  <cfp-portfolio-header
    class="d-print-none"
    [portfolio]="portfolio()"
    [labelGroup]="labelGroup()"
    [labelGroups]="labelGroups()"
    (clearFilters)="clearFilters($event)"
    (toggleM2)="toggleM2()"
    [(showM2)]="showM2"
    [filtersButtonDisabled]="isShowingFilters()"
    [activeFiltersCount]="filterBadges().length"
    (showFiltersSidePanel)="showFilters()"
    (showAddBuildingFlow)="showAddBuildingModal($event)"
  />

  <cfp-page-section [section]="'CONTENT_TOP'" />
  <cfp-page-section-portfolio [portfolioId]="portfolioId()" [section]="'PORTFOLIO_TOP'" />

  @if (filterBadges()?.length > 0) {
    <div class="mb-4 d-print-none row g-2">
      @for (item of filterBadges(); let index = $index; track item.value) {
        <cfp-filter-badge (clicked)="removeFilterBadge(index)" class="col-auto" [label]="item.display" />
      }
    </div>
  }

  <router-outlet [routerOutletData]="portfolioLayoutData()" />
</app-layout-container>
